<template>
  <c-container
    size="small"
    class="home-view"
  >
    <c-alert
      v-if="!extensionInstalled && !extensionInstalledLoading"
      icon="warning"
      color="warning"
      title="The extension is not installed yet."
      :action="{ title: 'Download from Chrome Webstore', target: '_blank', href: 'https://chrome.google.com/webstore/detail/notix/fmnbhafoldgblmdmhflflnjlfjcgpnog' }"
      :style="{ marginBottom: '2rem' }"
    />
    <connection-list />
  </c-container>
  <c-dialog
    v-model:visible="showIntroVideo"
  >
    <YouTube
      ref="youtube"
      width="840"
      height="473"
      src="https://www.youtube.com/watch?v=rLcyvLVTIOk"
      @ready="onVideoReady"
      @state-change="onStateChange"
    />
  </c-dialog>
  <pin-hint
    v-if="extensionInstalled && !pinHintDismissed && !extensionIsPinned && !extensionIsPinnedLoading"
    @hide="dismiss"
  />
</template>

<script>
import CAlert from 'shared/components/CAlert.vue';
import CContainer from 'shared/components/CContainer.vue';
import CDialog from 'shared/components/CDialog.vue';
import { BROWSER_SERVICE, FIREBASE_APP, SUBSCRIPTION_MANAGER, USER_SERVICE } from 'shared/constants';
import { signOut } from 'shared/services/firebase';
import useSettings from 'shared/services/settings';
import { inject, ref } from 'vue';
import YouTube from 'vue3-youtube';

import ConnectionList from '@/components/ConnectionList.vue';
import PinHint from '@/components/PinHint.vue';
import routes from '@/router/routes';
import useOnboarding from '@/services/onboarding';

export default {
  name: 'HomeView',
  components: { ConnectionList, CContainer, CAlert, PinHint, CDialog, YouTube },
  setup() {
    const { currentUser } = inject(USER_SERVICE);
    const browser = inject(BROWSER_SERVICE);
    const { extensionInstalled, extensionInstalledLoading, pinHintDismissed, extensionIsPinned, extensionIsPinnedLoading, dismiss } = useOnboarding(browser);
    const firebaseApp = inject(FIREBASE_APP);
    const userService = inject(USER_SERVICE);
    const subscriptionManager = inject(SUBSCRIPTION_MANAGER);
    const settingsService = useSettings(firebaseApp.db, userService.currentUser, subscriptionManager);
    const showIntroVideo = ref(false);
    settingsService.init();
    return { currentUser, routes, settingsLoading: settingsService.loading, showIntroVideo, settingsService, extensionInstalled, extensionInstalledLoading, pinHintDismissed, extensionIsPinned, extensionIsPinnedLoading, dismiss };
  },
  data() {
    return { introVideoClicked: false };
  },
  methods: {
    logout() {
      localStorage.clear();
      this.$subscriptionManager.unsubscribeAll();
      signOut(this.$auth).then(() => {
        window.location.href = import.meta.env.BASE_URL;
      });
    },
    onVideoReady(event) {
      event.target.playVideo();
    },
    onStateChange(event) {
      if (event.data === 1) {
        this.introVideoClicked = true;
      }
    },
  },
  watch: {
    showIntroVideo(newVal) {
      if (!newVal) {
        this.settingsService.save({ introVideoSeen: true, introVideoClicked: this.introVideoClicked });
      }
    },
    settingsLoading(newVal) {
      if (!newVal && this.settingsService.settings.value.introVideoSeen === undefined) {
        this.showIntroVideo = true;
      }
    },
  },
  mounted() {
    if (this.$route.query.error !== undefined) {
      this.$eventBus.emit('show-toast', {
        type: 'error',
        message: `Error connecting to Notion: ${this.$route.query.error}`,
      });
    }
  },
};
</script>

<style
    scoped
    type="text/scss"
    lang="scss"
>
.home-view {
  padding: 2rem;
}
</style>
